import type { ReactNode, Ref } from 'react'
import cx from 'classnames'
import styles from './LegendPill.module.css'

export interface LegendPillProps {
  children?: ReactNode
  shape?: 'pill' | 'square'
  /**
   * Sets the `--tone` custom property the pill is colored with, and
   * `--tone-surface` for a background other than a tint of it.
   */
  className?: string
  ref?: Ref<HTMLDivElement>
  testId?: string
}

/**
 * A small label in one of the legend builder's colors, like a value type or
 * a version's status.
 */
export function LegendPill({
  children,
  shape = 'pill',
  className,
  ref,
  testId,
}: LegendPillProps) {
  return (
    <div
      ref={ref}
      data-test={testId}
      className={cx(styles.root, styles[shape], className)}
    >
      {children}
    </div>
  )
}
